import { render, staticRenderFns } from "./Dettagli.vue?vue&type=template&id=b01e7116&"
import script from "./Dettagli.vue?vue&type=script&lang=js&"
export * from "./Dettagli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports